<!-- @veltra/icons generated sha256:6e683d3a47689cb0 gen:8 source:src/svg/normal/insert-to-next.svg -->
<script setup lang="ts">
defineOptions({ name: 'InsertToNext' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    viewBox="0 0 24 24"
  >
    <path d="M16 12H3m13-6H3m7 12H3M21 6v10a2 2 0 0 1-2 2h-5" />
    <path d="m16 16-2 2 2 2" />
  </svg>
</template>
